/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
import SectionTitle from '@components/HNI/Components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
/* Components */
/* Services */

/**
 * Renders the Quote Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data
 * @returns {ReactElement} Quote component
 */
const Texthni = ({ sectionContent }) => {
  const title = sectionContent.find(el => el._modelApiKey === 'section_title');
  return (
    <Box
      maxW={590}
      w="100%"
      mx="auto"
      maxH={{ base: '100%', md: '100%' }}
      px={{ base: '20px', md: '0' }}
      pt={{ base: '1rem', md: '80px', lg: '3rem' }}
      pb={{ md: '50px', lg: '3rem' }}
      textAlign={'center'}
    >
      <SectionTitle
        titleObj={title}
        fontSize={{ base: '26px', md: '30px' }}
        lineHeight={{ base: '47px' }}
      />
      <StructuredTextParser
        textAlign={'center'}
        color="#28231E"
        fontWeight={{ base: '400px', md: '350px' }}
        str={render(sectionContent[1]?.body)}
        w="100%"
        fontFamily="FedraSansStd-book"
        px="0"
        mt="40px"
        lineHeight="28px"
      />
    </Box>
  );
};

export default Texthni;
